import { get } from '../../api'
import { SimpleApi } from '../../api-action'
import { Transform } from '../../types/core'
import { FetchActivityItemsResponse, FetchSupplierOffersResponse, HistoryParams } from './types'

export const fetchApi = (url: string, params?: HistoryParams): SimpleApi<FetchActivityItemsResponse> =>
  get(url, { params })

export const fetchOfferActivitiesApi: Transform<string, SimpleApi<FetchSupplierOffersResponse>> = get
